import dropArrow from "../../../images/drop-arrow.png"; // eslint-disable-line

export default (theme) => ({
  careersForm: {
    position: "relative",
    marginBottom: 36,
    "& h1, & h2, & h3, & h4, & h5, & h6": {
      position: "relative",
      textAlign: "left !important",
      marginBottom: 30,
      [theme.breakpoints.up("md")]: {
        textAlign: "center !important",
        marginBottom: 60,
      },
    },
    "& .disclaimer": {
      lineHeight: 2,
      "& a": {
        color: theme.palette.primary.main,
        "&:hover, &:focus": {
          color: theme.palette.primary.dark,
        },
      },
    },
    // "& .cv-upload-wrap": {
    //   display: "block",
    //   textAlign: "center",
    //   padding: "20px",
    //   border: "2px dashed " + theme.palette.primary.main,
    // },
  },
  careersFormTheme: {
    ...theme.careersFormTheme,
  },
  label: {
    position: "relative",
    display: "block",
    fontSize: 14,
    textTransform: "uppercase",
    fontWeight: "bold",
    letterSpacing: "0.06em",
    fontFamily: theme.headerFont,
    marginBottom: 3,
  },
  inputs: {
    width: "100%",
    border: "none",
    borderRadius: 0,
    overflow: "hidden",
    backgroundColor: "white",
    marginBottom: 12,
    "& div": {
      padding: "0 !important",
    },
    "& input, & textarea, &.select": {
      position: "relative",
      border: "none",
      borderBottom: "2px solid " + theme.palette.primary.main,
      backgroundColor: "white",
      fontSize: 12,
      fontFamily: theme.bodyFont,
      letterSpacing: "0.01em",
      padding: "15px 20px",
      height: "auto !important",
      lineHeight: "1.2",
      "-webkit-appearance": "none",
      "-mox-appearance": "none",
      "& option": {
        fontFamily: theme.bodyFont,
        padding: "5px 20px",
        lineHeight: 2,
      },
      "&.select": {
        backgroundImage: "url(" + dropArrow + ")",
        backgroundSize: 18,
        backgroundPosition: "center right 10px",
        backgroundRepeat: "no-repeat",
        paddingRight: 38,
      },
    },
    "& textarea": {
      height: "100px !important",
      [theme.breakpoints.up("md")]: {
        height: "250px !important",
      },
    },
    "& fieldset": {
      display: "none",
    },
    "& .MuiInputBase-root": {
      marginBottom: "0 !important",
    },
    "&.has-error": {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      border: "2px solid " + theme.palette.primary.dark,
      borderBottom: "none",
    },
  },
  button: {
    display: "block",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: 14,
    border: "none",
    borderRadius: 4,
    textTransform: "uppercase",
    fontSize: 16,
    fontWeight: "bold",
    boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
    backgroundColor: theme.palette.primary.main,
    color: "white",
    fontFamily: theme.headerFont,
    letterSpacing: "0.06em",
    lineHeight: 1.15,
    marginTop: 40,
    textAlign: "left",
    marginBottom: 24,
    transition: "background-color .3s ease-in-out",
    "&:hover, &:focus": {
      backgroundColor: "#72ce9b",
    },
    "& img": {
      marginTop: 2,
      width: 14,
      float: "right",
      marginLeft: 20,
      verticalAlign: "middle",
    },
    [theme.breakpoints.up("md")]: {
      marginBottom: 0,
      maxWidth: 240,
      float: "right",
    },
    "&.cv-upload": {
      float: "none",
      textAlign: "center",
      margin: "0 auto",
      // backgroundColor: "transparent",
      // border: "2px dashed " + theme.palette.primary.main,
      // color: theme.palette.primary.main,
      width: "100%",
      maxWidth: "none",
      // borderRadius: 0,
      padding: 20,
      // boxShadow: "none",
    },
  },
  errors: {
    display: "block",
    position: "relative",
    border: "2px solid " + theme.palette.primary.dark,
    color: theme.palette.primary.dark,
    textAlign: "left",
    fontSize: 16,
    padding: 24,
    margin: "0 auto 72px",
    fontFamily: theme.headerFont,
    [theme.breakpoints.up("md")]: {
      maxWidth: 720,
    },
    "& svg": {
      verticalAlign: "bottom",
      marginRight: 24,
    },
  },
  recaptcha: {
    position: "relative",
    marginLeft: "auto",
    marginRight: "auto",
  },
  validationError: {
    position: "relative",
    padding: "6px 20px",
    marginTop: "-12px",
    marginBottom: 15,
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.contrastText,
    fontSize: 12,
    borderBottomLeftRadius: 22,
    borderBottomRightRadius: 22,
  },
  thanks: {
    display: "block",
    position: "relative",
    border: "2px solid " + theme.palette.secondary.main,
    color: theme.palette.secondary.main,
    textAlign: "left",
    fontSize: 16,
    padding: 24,
    margin: "0 auto 72px",
    fontFamily: theme.headerFont,
    [theme.breakpoints.up("md")]: {
      maxWidth: 700,
    },
    "& svg": {
      verticalAlign: "bottom",
      marginRight: 24,
    },
  },
});
